export const BUSINESS_PERFORMANCE_EXPECTATIONS = {
    exceeded: {
        en: 'Exceeded expectations',
        es: 'Superó las expectativas'
    },
    met: {
        en: 'Met expectations',
        es: 'Cumplió las expectativas'
    },
    some_met: {
        en: 'Somewhat met expectations',
        es: 'Cumplió parcialmente las expectativas'
    },
    not_met: {
        en: 'Did not at all meet expectations',
        es: 'No cumplió para nada las expectativas'
    },
    idk: {
        en: "Don't Know",
        es: 'No sé'
    },
    na: {
        en: 'N/A',
        es: 'N/A'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
